var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    ref: "el",
    attrs: {
      fancy: _vm.fancy,
      items: _vm.items,
      label: _vm.label,
      value: _vm.selectedValue,
    },
    on: {
      blur: function ($event) {
        return _vm.onBlur($event)
      },
      focus: function ($event) {
        return _vm.onFocus()
      },
      input: function ($event) {
        return _vm.onInput($event)
      },
      keyup: function ($event) {
        return _vm.onKeyup($event)
      },
      "item-click": function ($event) {
        return _vm.onSelect($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (p) {
          return [_vm._v(" " + _vm._s(p.item.text)), _c("br")]
        },
      },
    ]),
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v
      },
      expression: "input",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }